module.exports = __webpack_public_path__ + "static/media/1n4148.996cf65b.jpg";